var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 23.3333H2.33333C1.04222 23.3333 0 24.3756 0 25.6667C0 26.9578 1.04222 28 2.33333 28H25.6667C26.9578 28 28 26.9578 28 25.6667C28 24.3756 26.9578 23.3333 25.6667 23.3333ZM28 2.33333V18.6667C28 19.9578 26.9578 21 25.6667 21H2.33333C1.04222 21 0 19.9578 0 18.6667V2.33333C0 1.04222 1.04222 0 2.33333 0H25.6667C26.9578 0 28 1.04222 28 2.33333ZM19.5922 9.82333L10.6244 4.65111C10.1033 4.35556 9.45778 4.72889 9.45778 5.32778V15.68C9.45778 16.2789 10.1033 16.6522 10.6244 16.3567L19.5922 11.1844C20.1133 10.8889 20.1133 10.1344 19.5922 9.83889V9.82333Z",
    fill: "#00C8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/Videos.e3e2eebcfe1da791bd06eafa0774e127.svg";
export { ForwardRef as ReactComponent };